/**
 * Permissão da fila de aprovação de ASO.
 *
 * Arquivo próprio, e não o barrel: o router e a navbar precisam dela para decidir o que
 * renderizar, e importar do barrel arrastaria queries e mutations para o bundle inicial,
 * desfazendo o lazy load da página.
 *
 * As três rotas da API — inclusive a listagem — exigem `freeler:write:all`. A fila não é
 * consulta de apoio: existe para ser decidida, e cada linha carrega CPF e o PDF de um exame
 * ocupacional. Quem só lê o dossiê do profissional não entra aqui.
 */
const ASO_REVIEW_PERMISSION = "freeler:write:all";

const canReviewAso = (permissions: string[]) => permissions.includes(ASO_REVIEW_PERMISSION);

export { ASO_REVIEW_PERMISSION, canReviewAso };
